module.exports = __webpack_public_path__ + "static/assignroles2-af509212746a2d128484c7c43301395c.png";